import { Flex, FlexProps } from '@chakra-ui/react';
import { Place } from 'entities/place';
import React from 'react';
// eslint-disable-next-line no-restricted-imports
import { TopicCard } from 'shared/ui';

type EventTypePageMainEventsListProps = {
    events: Place[]
} & FlexProps & React.RefAttributes<HTMLDivElement>

export const PlacesPageMainList: React.FC<EventTypePageMainEventsListProps> = ({
    events,
    ...props
}) => (
    <Flex
        flexDirection="column"
        gap="2rem"
        {...props}
    >
        {events.map(({
            slug,
            name,
            description,
            images,
        }, index) => (
            <TopicCard
                key={slug}
                to={`/places/${slug}`}
                title={name}
                description={description || []}
                imagesContainerType={(index % 2) === 0 ? 1 : 2}
                imagesSrcs={images?.map(({ url }) => url) || []}
            />
        ))}
    </Flex>
);
